import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  TextField
} from '@mui/material';
import React, { useState } from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import * as yup from 'yup';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import FeedbackModal from './FeedbackModal';

const UpdatePassword = (): JSX.Element => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  // eslint-disable-next-line
  const [error, setError] = useState<any>({});
  const [showPassword, setShowPassword] = useState(false);
  const [searchParams] = useSearchParams();
  const [modalOpen, setModalOpen] = useState(false);

  function checkUppercase(str: string | undefined) {
    if (str) {
      for (let i = 0; i < str.length; i++) {
        if (
          str.charAt(i) == str.charAt(i).toUpperCase() &&
          str.charAt(i).match(/[a-z]/i)
        ) {
          return true;
        }
      }
    }
    return false;
  }
  function hasNumber(str: string | undefined) {
    if (str) {
      return /\d/.test(str);
    }
    return false;
  }
  function hasSpecialChar(str: string | undefined) {
    if (str) {
      return /[!@#$%&*]/.test(str);
    }
    return false;
  }

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const schema = yup.object({
    password: yup
      .string()
      .min(8, 'Password must be at least 8 characters')
      .required()
      .test('hasUpperCase', 'Missing uppercase', checkUppercase)
      .test('hasNumber', 'Missing number', hasNumber)
      .test('hasSpecialChar', 'Missing special char', hasSpecialChar),
    confirm: yup
      .string()
      .required()
      .test('equalsPassword', 'Passwords should be equal', (e) => e == password)
  });

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Box
        sx={{
          maxWidth: '480px',
          p: '20px 30px'
        }}
      >
        <Box sx={{ marginX: 'auto', mb: 8, textAlign: 'center' }}>
          <Box
            sx={{
              width: '100%',
              mb: '80px',
              display: 'flex',
              justifyContent: 'center'
            }}
          >
            <svg
              width="345"
              height="100"
              viewBox="0 0 345 100"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M44.1379 66.3793C44.1379 70.5172 45.1724 73.9655 47.4138 76.5517C49.6551 79.1379 52.5862 80.5172 56.0344 80.5172C59.6551 80.5172 62.7586 79.3103 65 76.7241C67.2413 74.1379 68.4482 70.6896 68.4482 66.7241C68.4482 62.5862 67.2413 59.3103 65 56.7241C62.7586 54.1379 59.8275 52.931 56.2069 52.931C52.7586 52.931 49.8275 54.3103 47.5862 56.8965C45.1724 59.3103 44.1379 62.5862 44.1379 66.3793ZM67.7586 45H77.7586V88.1034H67.7586V83.6207C63.6207 87.4138 59.1379 89.3103 54.4827 89.3103C48.4482 89.3103 43.6207 87.0689 39.6551 82.7586C35.862 78.2758 33.7931 72.931 33.7931 66.2069C33.7931 59.6551 35.6896 54.3103 39.6551 50C43.4482 45.6896 48.4482 43.4482 54.1379 43.4482C59.1379 43.4482 63.6207 45.5172 67.5862 49.6551V45H67.7586Z"
                fill="#231F20"
              ></path>
              <path
                d="M96.0345 13.2759V88.1035H86.0345V13.2759H96.0345Z"
                fill="#231F20"
              ></path>
              <path
                d="M114.31 13.2759V88.1035H104.31V13.2759H114.31Z"
                fill="#231F20"
              ></path>
              <path
                d="M128.103 45.0001L139.31 69.6552L151.552 41.0345L163.793 69.6552L175 45.0001H186.207L163.621 91.3794L151.552 63.6208L139.31 91.3794L116.724 45.0001H128.103Z"
                fill="#231F20"
              ></path>
              <path
                d="M195.172 66.3793C195.172 70.6896 196.379 74.1379 198.621 76.5517C201.034 79.1379 204.138 80.3448 207.931 80.3448C211.896 80.3448 215 79.1379 217.241 76.5517C219.655 73.9655 220.69 70.6896 220.69 66.5517C220.69 62.4138 219.483 58.9655 217.241 56.5517C214.828 53.9655 211.724 52.7586 207.931 52.7586C204.138 52.7586 201.034 53.9655 198.621 56.5517C196.207 59.1379 195.172 62.4138 195.172 66.3793ZM184.827 66.2069C184.827 60 187.069 54.6552 191.552 50.3448C196.034 46.0345 201.379 43.7931 207.931 43.7931C214.31 43.7931 219.828 46.0345 224.31 50.3448C228.793 54.8276 231.034 60.1724 231.034 66.5517C231.034 73.1034 228.793 78.4483 224.31 82.7586C219.828 87.069 214.31 89.3103 207.759 89.3103C201.207 89.3103 195.862 87.069 191.552 82.5862C187.069 78.4483 184.827 72.931 184.827 66.2069Z"
                fill="#231F20"
              ></path>
              <path
                d="M237.241 45H247.241V48.7931C249.138 46.8965 250.69 45.5172 252.069 44.8276C253.448 44.1379 255.172 43.7931 257.241 43.7931C259.828 43.7931 262.586 44.6552 265.517 46.3793L260.862 55.5172C258.965 54.1379 257.069 53.4483 255.345 53.4483C249.828 53.4483 247.241 57.5862 247.241 65.8621V88.2758H237.241V45Z"
                fill="#231F20"
              ></path>
              <path
                d="M278.276 13.2759V58.9655L292.241 45H305.69L286.896 63.1035L307.069 88.1035H294.138L279.828 70L278.276 71.5518V88.1035H268.276V13.2759H278.276Z"
                fill="#231F20"
              ></path>
              <path
                d="M11.8966 0L24.1379 4.13793L23.7931 4.65517C20 12.5862 17.2414 20.1724 15.6897 26.7241C15 30.1724 14.3103 33.7931 13.9655 37.5862C13.6207 41.3793 13.4483 45.5172 13.4483 50C13.4483 54.4828 13.6207 58.7931 13.9655 62.4138C14.4828 66.2069 15 69.8276 15.6897 73.2759C17.2414 80 20 87.4138 23.7931 95.3448L24.1379 95.8621L11.8966 100L11.7241 99.4827C7.93103 92.4138 4.82759 84.6552 2.93103 76.5517C0.862069 68.2759 0 59.3103 0 49.8276C0 40.3448 1.03448 31.5517 2.93103 23.2759C5 15.1724 7.93103 7.41379 11.7241 0.344827L11.8966 0Z"
                fill="#72C4E6"
              ></path>
              <path
                d="M332.586 100L320.345 95.8621L320.69 95.3448C324.483 87.4138 327.241 80 328.793 73.2759C329.483 69.8276 330.172 66.2069 330.517 62.4138C330.862 58.6207 331.035 54.4828 331.035 50C331.035 45.5172 330.862 41.3793 330.517 37.5862C330 33.7931 329.483 30.1724 328.793 26.7241C327.241 20.1724 324.483 12.5862 320.69 4.65517L320.345 4.13793L332.586 0L332.759 0.517241C336.552 7.58621 339.655 15.3448 341.552 23.4483C343.621 31.7241 344.483 40.5172 344.483 50C344.483 59.4828 343.448 68.2759 341.552 76.7241C339.483 84.8276 336.552 92.5862 332.759 99.6552L332.586 100Z"
                fill="#72C4E6"
              ></path>
            </svg>
          </Box>
          <PageTitle>Update Password</PageTitle>
        </Box>
        <Box>
          <FormControl fullWidth>
            Email
            <TextField
              id="Email"
              sx={{
                mb: 2,
                height: '50px',
                borderRadius: '40px'
              }}
              InputProps={{
                style: {
                  borderRadius: '40px',
                  height: '50px'
                }
              }}
              value={searchParams.get('email')}
              disabled
              type={'text'}
            />
          </FormControl>
          <FormControl fullWidth>
            New password
            <TextField
              sx={{
                mb: Object.keys(error).length > 0 ? 4 : 2,
                borderRadius: '40px',
                height: '50px'
              }}
              id="password"
              value={password}
              error={Object.keys(error).length > 0}
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                style: {
                  lineHeight: '10px',
                  borderRadius: '40px',
                  height: '50px'
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              onChange={(e) => setPassword(e.target.value)}
              helperText={
                Object.keys(error).length > 0 ? error.inner[0].message : ''
              }
            />
          </FormControl>
          <FormControl fullWidth>
            Confirm password
            <TextField
              sx={{
                mb: 2,
                borderRadius: '40px',
                height: '50px'
              }}
              id="confirm"
              value={confirm}
              type={showPassword ? 'text' : 'password'}
              error={
                password.length > 0 &&
                confirm.length > 0 &&
                confirm !== password
              }
              InputProps={{
                style: {
                  borderRadius: '40px',
                  height: '50px'
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              helperText={
                password.length > 0 &&
                confirm.length > 0 &&
                confirm !== password
                  ? 'Passwords should be equal'
                  : ''
              }
              onChange={(e) => setConfirm(e.target.value)}
            />
          </FormControl>
        </Box>
        <Box>
          <ul>
            <li>At least 8 characters</li>
            <li>At least one upper case letter (A-Z)</li>
            <li>At least one number (0-9)</li>
            <li>At least one of the following: @#!$%*</li>
          </ul>
        </Box>
        <Button
          onClick={() => {
            schema
              .validate({ password, confirm }, { abortEarly: false })
              .then(() => {
                axios
                  .post(
                    process.env.REACT_APP_BASE_URL + '/user/reset-password',
                    {
                      password: password,
                      token: searchParams.get('token')
                    },
                    { headers: { Authorization: '' } }
                  )
                  .then(() => {
                    setModalOpen(true);
                  });
              })
              .catch((error) => {
                setError(error);
                // eslint-disable-next-line
                error.inner.forEach((e: any) => {});
              });
          }}
          sx={{ width: '100%', px: 5, borderRadius: '40px', mt: '30px' }}
        >
          Submit
        </Button>
      </Box>
      <FeedbackModal
        open={modalOpen}
        setOpen={(e) => setModalOpen(e)}
        user={searchParams.get('email')}
      />
    </Box>
  );
};

export default UpdatePassword;
